const kebabCase = require('lodash/kebabCase')
const {
  DEFAULT_LOCATION_ID_HIERARCHY
} = require('../tools/get-region-level-sub-tiers')

module.exports.buildLocationId = (
  location,
  hierarchy = DEFAULT_LOCATION_ID_HIERARCHY
) => {
  const parts = hierarchy.map((level) => {
    if (!location[level]) {
      throw new Error(`Required element of location: ${level} is missing`)
    }
    return `${level}:${kebabCase(location[level])}`
  })

  return parts.join(':')
}
